import React from 'react';
import { View } from 'react-native';

import { PageTestId } from '../../constants/test-id';
import LoginForm from '../../organisms/login-form/login-form';
import { pt, width } from '../../style-utils';
import LoginPageTemplate from '../../templates/login-page-template/login-page-template';

export type LoginPageProps = {
  title?: string;
  onRecoverPassword: () => void;
  onRecoverUsername: () => void;
};

export const LoginPage: React.FC<LoginPageProps> = ({
  title,
  onRecoverPassword,
  onRecoverUsername,
}) => {
  return (
    <LoginPageTemplate title={title || 'Teacher Portal'}>
      <View style={[width(330), pt(63)]} testID={PageTestId.LOGIN}>
        <LoginForm
          onRecoverPassword={onRecoverPassword}
          onRecoverUsername={onRecoverUsername}
          labels={{
            usernameLabel: 'Username',
            usernameLink: 'Forgot your username?',
            passwordLabel: 'Password',
            passwordLink: 'Forgot your password?',
            buttonSubmit: 'Login',
          }}
        />
      </View>
    </LoginPageTemplate>
  );
};

export default LoginPage;
